document.addEventListener('DOMContentLoaded', () => {
    const confirmMaximumAmountContent = document.getElementById('confirm_maximum_amount_content');
    const confirmUpperLimitPolicyCheckbox = document.getElementById('confirm_upper_limit_policy');
    const confirmSiteSurveyContent = document.getElementById('confirm_site_survey_content');
    const confirmSiteSurveyNotesCheckbox = document.getElementById('confirm_site_survey_notes');
    const submitBtn = document.getElementById('order_confirm_submit_btn');

    if (!submitBtn) {
        return;
    }

    if (!confirmSiteSurveyContent && !confirmMaximumAmountContent) {
        submitBtn.classList.remove('is-disabled');
    }
    /**
     * スクロール領域の末尾まで読んだら同意チェックボックスを活性化する。
     * 中身が短くスクロールが発生しない場合は scroll イベントが飛ばないため、初期表示とレイアウト確定後にも判定する。
     *
     * @param {HTMLElement|null} scrollContainer
     * @param {HTMLInputElement|null} checkbox
     * @param {number} [threshold=5]
     */
    function bindEnableCheckboxWhenScrolledToBottom(scrollContainer, checkbox, threshold = 5) {
        if (!scrollContainer || !checkbox) {
            return;
        }

        function updateCheckboxEnabled() {
            const scrolledToBottom =
                scrollContainer.scrollHeight - scrollContainer.scrollTop - scrollContainer.clientHeight <= threshold;

            if (scrolledToBottom) {
                checkbox.disabled = false;
            }
        }

        scrollContainer.addEventListener('scroll', updateCheckboxEnabled);
        updateCheckboxEnabled();
        requestAnimationFrame(() => updateCheckboxEnabled());
    }

    /**
     * 同意チェックの組み合わせに応じて送信ボタンの disabled / 見た目を更新する。
     * 対象チェックがどちらも無い場合は送信ボタンを触らない。
     */
    function checkSubmitBtnDisabled() {
        const hasUpperLimitPolicy = Boolean(confirmUpperLimitPolicyCheckbox);
        const hasSiteSurveyNotes = Boolean(confirmSiteSurveyNotesCheckbox);

        let isSubmitEnabled;
        if (hasUpperLimitPolicy && hasSiteSurveyNotes) {
            isSubmitEnabled =
                confirmUpperLimitPolicyCheckbox.checked && confirmSiteSurveyNotesCheckbox.checked;
        } else if (hasUpperLimitPolicy) {
            isSubmitEnabled = confirmUpperLimitPolicyCheckbox.checked;
        } else if (hasSiteSurveyNotes) {
            isSubmitEnabled = confirmSiteSurveyNotesCheckbox.checked;
        } else {
            return;
        }

        submitBtn.disabled = !isSubmitEnabled;
        submitBtn.classList.toggle('is-disabled', !isSubmitEnabled);
    }

    if (confirmSiteSurveyContent && confirmSiteSurveyNotesCheckbox) {
        // 画面表示を行う際、チェックボックスを解除(現地調査に関する注意事項)
        confirmSiteSurveyNotesCheckbox.checked = false;
        bindEnableCheckboxWhenScrolledToBottom(confirmSiteSurveyContent, confirmSiteSurveyNotesCheckbox);
        // 同意チェックボックス変更時アクション(現地調査に関する注意事項)
        confirmSiteSurveyNotesCheckbox.addEventListener('change', checkSubmitBtnDisabled);
    }

    if (confirmUpperLimitPolicyCheckbox) {
        // 画面表示を行う際、チェックボックスを解除(上限金に関する確認事項)
        confirmUpperLimitPolicyCheckbox.checked = false;
        bindEnableCheckboxWhenScrolledToBottom(confirmMaximumAmountContent, confirmUpperLimitPolicyCheckbox);
        // 同意チェックボックス変更時アクション(上限金に関する確認事項)
        confirmUpperLimitPolicyCheckbox.addEventListener('change', checkSubmitBtnDisabled);
    }
});
